export default __webpack_public_path__ + "static/illu_delivery-768b4466a761b560078d033792067763.png";